<template>
<!-- 敬请期待 -->
    <div class="expect">
        <div class="content">
            <img src="../assets/icon @2x.png">
            <p>此功能正在紧张开发中</p>
            <p>敬请期待...</p>
        </div>
    </div>
</template>

<script>
export default {
    props: {

    },
    data() {
        return {

        };
    },
    computed: {

    },
    created() {

    },
    mounted() {

    },
    watch: {

    },
    methods: {

    },
    components: {

    },
};
</script>

<style scoped>
.expect {
    height: 100%;
}
.content {
    color: #3f8ed4;
    text-align: center;
    background: #fff;
    height: 100%;
}
.content img {
    margin-top: 200px;
    width: 420px;
}

.content p:first-of-type {
    font-size: 36px;
    margin: 80px 0 30px;
}
.content p:last-of-type {
    font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/views/Expect.vue